import { gql } from '@apollo/client';

export const EXTRA_DATA_FIELDS = gql`
  fragment ExtraDataFields on UnionExtraDataListObjectType {
    totalCount
    items {
      ... on CardCommentSchema {
        id
        text
        updatedAt
        isSuspicious
        createdAt
        user {
          ...PreviewActionUser
        }
        collection {
          id
          cardId
          type
          title
        }
      }
      ... on CollectionCardLinkSchema {
        id
        cardPickId
        user {
          ...PreviewActionUser
        }
        collection {
          id
          type
          title
          cardId
        }
        card {
          id
          type
          cardId
        }
      }
      ... on CardPickSchema {
        id
        cardId
        createdAt
        user {
          ...PreviewActionUser
        }
      }
    }
  }
`;

export const PREVIEW_IMAGES = gql`
  fragment PreviewImages on CardSchema {
    cardStyle {
      thumbnailImageSet {
        imageId
        images(filters: { imageType: PREVIEW }) {
          url
          fontColor
          id
        }
        id
      }
    }
  }
`;

export const CORE_USER_FIELDS = gql`
  fragment CoreUserFields on UserObjectType {
    id
    username
    cardId
    isVerified
    userInfo {
      firstName
      lastName
      bio
    }
  }
`;

export const PREVIEW_ACTION_USER = gql`
  fragment PreviewActionUser on UserObjectType {
    ...CoreUserFields
    userStyle {
      id
      thumbnailImageSet {
        id
        imageId
        images(filters: { imageType: PREVIEW }) {
          url
          id
        }
      }
    }
    isNotificationsEnable
    isBlockedByMe
    isBlockedMe
    isFollowedByMe
    isFollowingMe
    isMutedByMe
  }
`;

export const COVER_FIELDS = gql`
  fragment CoverFields on CollectionCoverSchema {
    totalCount
    items {
      ... on ImageSetSchema {
        id
        imageId
        images(filters: { imageType: PREVIEW }) {
          id
          url
          aspectRatio
        }
      }
      ... on CardTitleObjectType {
        title
      }
    }
  }
`;

export const COLLECTION_COVER_IMAGES = gql`
  fragment CollectionCover on CardStyleSchema {
    collectionCover(limit: 4) {
      ...CoverFields
    }
    collectionBgColors {
      colorValue
      id
    }
  }
`;

export const PREVIEW_CARD = gql`
  fragment PreviewCard on CardSchema {
    id
    cardId
    pickId
    type
    title
    extractResult
    extractionStatus
    isPickedByMe
    isPrivate
    isPrivateList
    isHidden
    permissions(referrerCardId: $refListId)
    hasNewCollaboratorsCards
    creators(limit: 6) {
      totalCount
      items {
        user {
          ...PreviewActionUser
        }
      }
    }
    externalCreators(limit: 1, offset: 1) {
      totalCount
      items {
        id
        cardId
        creatorName
        creatorUsername
      }
    }
    externalSources {
      totalCount
      items {
        id
        sourceUrl
        sourceDomainName
      }
    }
    tags(limit: 1) {
      totalCount
      items {
        id
        name
      }
    }
    mediaTags(limit: 1) {
      totalCount
      items {
        id
        name
      }
    }
    cardStyle {
      bgStyle
      layout
      id
      isDefaultStyle
      bgColor {
        id
        colorId
        colorType
        colorValue
        fontColor
        gradientStart
        gradientEnd
        predefinedGradientName
      }
    }
    sourceName
  }
`;

export const PICKED_BY_USERS_FIELDS = gql`
  fragment PickedByUsersFields on UserListObjectType {
    totalCount
    items {
      ...CoreUserFields
      userStyle {
        id
        thumbnailImageSet {
          id
          imageId
          images(filters: { imageType: PREVIEW }) {
            url
            id
          }
        }
      }
    }
  }
`;

export const PICKED_BY_USERS = gql`
  fragment PickedByUsers on CardSchema {
    pickedByUsers(filters: { pickedInCollection: $refListId, mutedByMe: false }, limit: 3) {
      ...PickedByUsersFields
    }
  }
`;
